<script>
    import { getContext } from 'svelte';
    import { TABS } from './Tabs.svelte';

    const { selectedTab } = getContext(TABS);

</script>

<div>
	<slot />
    <svelte:component this={$selectedTab.component} {...$selectedTab.props} />
</div>
